import React from 'react';
import { PrinterOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';

class PrintButton extends React.Component {
    constructor(props) {
        super(props);
        // Tạo id duy nhất cho mỗi instance
        this.printId = `print-content-${Math.random().toString(36).substring(2, 9)}`;
    }

    handlePrint = () => {
        const printElement = document.getElementById(this.printId);
        if (!printElement) return;

        const content = printElement.innerHTML;
        const printWindow = window.open('', '', 'width=900,height=800');
        printWindow.document.open();
        printWindow.document.write(`
            <html>
                <head>
                    <title>Print</title>
                    <style>
                        body { font-family: 'Times New Roman', serif; margin: 20px; }
                        @page { size: A4; margin: 1cm; }
                    </style>
                </head>
                <body>${content}</body>
            </html>
        `);
        printWindow.document.close();

        // Đảm bảo in sau khi render xong nội dung
        printWindow.onload = function () {
            printWindow.focus();
            printWindow.print();
        };
    };

    render() {
        const { printText = "In phiếu", size = "default", disabled = false, tooltipText, children } = this.props;

        return (
            <>
                <Tooltip title={tooltipText}>
                    <Button
                        disabled={disabled}
                        size={size}
                        icon={<PrinterOutlined />}
                        //onClick={this.handlePrint}
                        onClick={(e) => {
                            e.stopPropagation();   // chặn mở Collapse
                            this.handlePrint(e);   // tiếp tục chạy in
                        }}
                        {...this.props}
                    >
                        {printText}
                    </Button>
                </Tooltip>

                {/* Vùng in ẩn — mỗi nút có ID riêng */}
                <div id={this.printId} style={{ display: 'none' }}>
                    {children}
                </div>
            </>
        );
    }
}

export default PrintButton;


// import React from 'react';
// import { PrinterOutlined } from '@ant-design/icons';
// import { Button, Tooltip } from 'antd';

// class PrintButton extends React.Component {

//     handlePrint = () => {
//         const content = document.getElementById('custom-print-content').innerHTML;
//         const printWindow = window.open('', '', 'width=900,height=800');
//         printWindow.document.open();
//         printWindow.document.write('<html><head><title>Print</title></head><body>');
//         printWindow.document.write(content);
//         printWindow.document.write('</body></html>');
//         printWindow.document.close();
//         printWindow.print();
//     };


//     render() {

//         const { printText = "In phiếu", size = "default", disabled = false, tooltipText } = this.props;

//         return (
//             <Tooltip title={tooltipText}>
//                 <Button disabled={disabled} size={size} icon={<PrinterOutlined />} onClick={this.handlePrint}>{printText}</Button>
//                 <span id="custom-print-content" style={{ display: 'none' }}>
//                     <span>
//                         {this.props.children}
//                     </span>
//                 </span>
//             </Tooltip>
//         );
//     }
// }

// export default PrintButton;
